export const LANG_EN_NAME = "en";

export const LANG_EN_TRANS = {
	"download.button": "Download",
	// tslint:disable-next-line:max-line-length
	"download.configuration.message": "After your virtual appliance has been successfully installed, setup will continue in the virtual machine console",
	"download.info.title": "Download SafeConnect",
	"download.info.block.1": "Click",
	"download.info.block.2": "here",
	"download.info.block.3": "to view the installation guide.",
	"download.info.block.3.alt": "to go back to the download page",
	"download.info.block.4": "For assistance, you can reach us on the ",
	"download.media.version": "Version",
	"download.media.size": "Size",
	"download.media.unselected": "Please select the media for your installation.",
	"download.statusMessage.404": "There was an error downloading your file, please contact support for help.",
	"download.statusMessage.200": "Your file download has started.",
	"footer.rights": "ALL RIGHTS RESERVED",
	"header.sub.title": "Cloud Portal",
	"footer.copyright": `Impulse - Acquired by OPSWAT. All rights reserved. Impulse, SafeConnect, OPSWAT&reg;,<br>the Impulse logo and the
	OPSWAT logo are trademarks of OPSWAT, Inc.`
}
